import { Box, Typography } from '@mui/material'
import { howToJoinSteps } from '../../data/changeMakerContent'
import { sectionHeadingSx } from '../../theme/mobileLayout'

function StepCard({ step, title, description, stepBg, stepColor }) {
  return (
    <Box
      sx={{
        flex: { lg: '1 1 0' },
        minWidth: 0,
        bgcolor: '#fffefa',
        borderRadius: '20px',
        boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.12)',
        p: '24px',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 6, md: '50px' } }}>
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '10px',
            bgcolor: stepBg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: '10px',
            boxSizing: 'border-box',
            flexShrink: 0,
          }}
        >
          <Typography
            sx={{
              fontSize: 28,
              lineHeight: 'normal',
              fontWeight: 400,
              color: stepColor,
              letterSpacing: '3.4px',
            }}
          >
            {step}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <Typography
            sx={{
              fontSize: { xs: 24, md: 28 },
              lineHeight: 'normal',
              fontWeight: 400,
              color: '#111',
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: 16, md: 20 },
              lineHeight: '24px',
              fontWeight: 400,
              color: 'rgba(17,17,17,0.6)',
            }}
          >
            {description}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default function ChangeMakerHowToJoinSection() {
  return (
    <Box
      component="section"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: 5, md: '80px' },
        width: '100%',
      }}
    >
      <Typography component="h2" sx={sectionHeadingSx}>
        How To Join?
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
          gap: '40px',
          width: '100%',
        }}
      >
        {howToJoinSteps.map((item) => (
          <StepCard key={item.step} {...item} />
        ))}
      </Box>
    </Box>
  )
}
